import * as Yup from "yup";

// Multi-lingual support
import { t } from "i18next";

// Validation schemas for basic details
export const getBasicDetailsValidationSchema = () =>
  Yup.object({
    agentId: Yup.string().required(t("addUpdateFarmer.agentRequired")),
    name: Yup.string()
      .trim()
      .required(t("addUpdateFarmer.firstNameRequired"))
      .matches(/^\S+$/, t("addUpdateFarmer.noSpacesAllowed"))
      // .min(3, t("addUpdateFarmer.min3Characters"))
      .max(50, t("addUpdateFarmer.max50Characters")),
    lastName: Yup.string()
      .trim()
      .matches(/^\S+$/, t("addUpdateFarmer.noSpacesAllowed"))
      // .min(3, t("addUpdateFarmer.min3Characters"))
      .max(50, t("addUpdateFarmer.max50Characters"))
      .required(t("addUpdateFarmer.lastNameRequired")),
    nationalId: Yup.string()
      .trim()
      .length(13, t("addUpdateFarmer.nationalIdLength")),
    // .required(t("addUpdateFarmer.nationalIdRequired")),
    dateOfBirth: Yup.date()
      .nullable()
      .typeError("Invalid date format") // Handles invalid date
      // .required(t("addUpdateFarmer.dobRequired"))
      .test("min-age", t("addUpdateFarmer.minAgeError"), (value) => {
        if (!value) return true;
        const age = new Date().getFullYear() - value.getFullYear();
        return age >= 18;
      })
      .test("max-age", t("addUpdateFarmer.maxAgeError"), (value) => {
        if (!value) return true;
        const age = new Date().getFullYear() - value.getFullYear();
        return age < 120;
      }),
    internalId: Yup.string().trim().nullable(),
    projectId: Yup.string().required(t("addUpdateFarmer.projectRequired")),
  });
